import { Link } from 'react-router-dom';
import { Check } from '../Icons';
import { Brand } from '../Brand';

export default function Hero() {
  return (
    <section className="hero container">
      <div className="hero__grid">
        {/* Copy */}
        <div>
          <p className="hero__kicker">Running a small business in the UK with no support?</p>
          <h1 className="hero__title">Stop losing hours getting HR right</h1>
          <p className="hero__lead">
            As a company owner you’re already juggling too much. <Brand /> is an AI HR assistant
            built on UK employment law and ACAS guidance. It checks your documents and policies, helps you keep them up to date, and gives you clear, practical answers grounded in your real business. Spend your time building your
            business, not second-guessing a flexible working policy.
          </p>
          <div className="hero__cta">
            <Link to="/waitlist" className="btn btn-primary">
              Start for free
            </Link>
            <a href="#how-it-works" className="btn btn-secondary">
              See how it works
            </a>
          </div>
          <div className="hero__badges">
            <span className="hero__badge">
              <Check /> No credit card
            </span>
            <span className="hero__badge">
              <Check /> Set up in minutes
            </span>
            <span className="hero__badge">
              <Check /> Cancel anytime
            </span>
          </div>
        </div>

        {/* Product panel mockup: a conversation with the AI assistant */}
        <div className="panel">
          <div className="panel__backdrop" aria-hidden="true" />
          <div className="panel__card">
            <div className="panel__head">
              <div className="panel__head-left">
                <span className="panel__badge-icon">
                  <span className="panel__badge-dot" />
                </span>
                <span className="panel__title">
                  Ask <Brand />
                </span>
              </div>
              <span className="panel__status">
                <span className="panel__status-dot" />
                Online
              </span>
            </div>
            <div className="hchat">
              <div className="hchat__msg hchat__msg--user">
                Someone's just resigned. What do I need to do?
              </div>
              <div className="hchat__msg hchat__msg--bot">
                Get their resignation in writing and confirm their last day. Their contract puts them
                on one month's notice, so their last day is 14 August. Here's how to offboard them
                properly.
              </div>
              <div className="hchat__ground">
                <span className="hchat__ground-icon">
                  <Check size={10} color="#fff" strokeWidth={3.4} />
                </span>
                Grounded in your Employment contract
              </div>
              <div className="hchat__input">
                <span className="hchat__input-text">Ask about anything…</span>
                <span className="hchat__send" aria-hidden="true">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12h13M13 6l6 6-6 6"
                      stroke="#fff"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* Floating checklist */}
          <div className="panel__float panel__float--checklist">
            <div className="panel__float-head">
              <span className="panel__float-dot" />
              Your documents
            </div>
            <div className="doc-mini">
              <div className="doc-mini__row">
                <span className="doc-mini__tick">
                  <Check size={9} color="#fff" strokeWidth={3.4} />
                </span>
                Employment contract
              </div>
              <div className="doc-mini__row">
                <span className="doc-mini__tick">
                  <Check size={9} color="#fff" strokeWidth={3.4} />
                </span>
                Health &amp; safety policy
              </div>
              <div className="doc-mini__row doc-mini__row--warn">
                <span className="doc-mini__warn">!</span>
                Disciplinary policy
                <span className="doc-mini__flag">Update</span>
              </div>
            </div>
            <div className="doc-mini__foot">
              <span className="doc-mini__foot-dot" />
              Checked today · 86% compliant
            </div>
          </div>

          {/* Floating law change */}
          <div className="panel__float panel__float--law">
            <div className="panel__float-head">
              <span className="panel__float-dot" />
              Law change · Apr 2026
            </div>
            <div className="panel__float-body">
              Day-one sick pay is now in force. 1 policy needs a tweak.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
